import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Popconfirm, Tooltip } from "antd";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

import menuImage from "../../assets/images/menu.svg";
import Image from "../../assets/images/TeamexHandSymbol.png";
import { getUserIcon } from "../../utils/images";

import {
  adminDashboardMenu,
  employeeDashboardMenu,
  wareHouseDashboardMenu,
} from "../../helper/sidebarPath/SidebarPath";

import COLORS from "../../constants/colors";
import { QueryClient } from "@tanstack/react-query";
import { notifySuccess } from "../../utils/ToastifyProvider";

const Sidebar = ({ userType, userId }) => {
  const [subMenuOpen, setSubMenuOpen] = useState("");
  const navigate = useNavigate();

  const firstname = localStorage.getItem("firstName") || {};
  const lastname = localStorage.getItem("lastName") || {};
  const gender = localStorage.getItem("gender") || {};
  const queryClient = new QueryClient();

  let userRoutes = [];
  if (userType === "admin") userRoutes = adminDashboardMenu;
  else if (userType === "manager") userRoutes = wareHouseDashboardMenu;
  else userRoutes = employeeDashboardMenu;

  const handleLogout = () => {
    queryClient.clear();
    localStorage.clear();
    notifySuccess("Logout successful! Redirecting...");
    setTimeout(() => {
      navigate("/login", { replace: true });
      window.location.reload();
    }, 2000);
  };

  return (
    <aside className="h-screen w-20 bg-white border-r border-gray-200 flex flex-col justify-between">
      {/* Logo */}
      <div className="flex justify-center mt-4">
        <img src={Image} alt="Logo" className="w-16 h-16 rounded-full" />
      </div>

      {/* Menu */}
      <nav className="flex-1 space-y-1 flex flex-col items-center">
        {userRoutes.map((route) =>
          route.submenu?.length ? (
            <div key={route.name} className="w-full text-center">
              <Tooltip title={route.name} placement="right">
                <button
                  onClick={() =>
                    setSubMenuOpen(subMenuOpen === route.name ? "" : route.name)
                  }
                  className={`flex items-center justify-center w-full py-3 ${
                    subMenuOpen === route.name
                      ? `bg-[${COLORS.primaryLight}] text-[${COLORS.primary}]`
                      : `hover:bg-[${COLORS.primaryLight}] hover:text-[${COLORS.primary}]`
                  }`}
                >
                  {route.icon}
                </button>
              </Tooltip>
              {/* Submenu (dropdown to right side) */}
              {subMenuOpen === route.name && (
                <div className="absolute left-20 bg-white shadow-md rounded-lg">
                  {route.submenu.map((sub) => (
                    <NavLink
                      key={sub.name}
                      to={sub.path}
                      className={({ isActive }) =>
                        `block px-4 py-2 text-sm ${
                          isActive
                            ? `text-[${COLORS.primary}] bg-[${COLORS.primaryLight}]`
                            : `hover:text-[${COLORS.primary}] hover:bg-[${COLORS.primaryLight}]`
                        }`
                      }
                    >
                      {sub.name}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <Tooltip key={route.name} title={route.name} placement="right">
              <NavLink
                to={route.path}
                className={({ isActive }) =>
                  `flex items-center justify-center w-full py-3 ${
                    isActive
                      ? `text-[${COLORS.primary}] bg-[${COLORS.primaryLight}]`
                      : `hover:text-[${COLORS.primary}] hover:bg-[${COLORS.primaryLight}]`
                  }`
                }
              >
                {route.icon}
              </NavLink>
            </Tooltip>
          )
        )}
      </nav>

      {/* Profile + Logout */}
      <div className={`border-t border-gray-200 p-4 flex justify-center`}>
        <Tooltip title="Logout" placement="right">
          <Popconfirm
            title="Are you sure you want to logout?"
            onConfirm={handleLogout}
            okText="Yes"
            cancelText="No"
            placement="right"
          >
            <img
              src={getUserIcon(gender, userId)}
              alt="User"
              className="w-10 h-10 rounded-full cursor-pointer"
            />
          </Popconfirm>
        </Tooltip>
      </div>
    </aside>
  );
};

export default Sidebar;
